import {BilledFeature} from "../../libs/enum/billed-feature.enum";

export class OrgFeatureQuotaDto {

  public readonly description!: string;
  public readonly billedFeature!: BilledFeature;
  public readonly initialQuota!: number;
  public readonly usedQuota!: number;
  public readonly pos!: number;
  public readonly quotaExceeded!: boolean;
  public readonly quotaReached!: boolean;

  constructor(init?: Partial<OrgFeatureQuotaDto> | undefined) {
    Object.assign(this, init);
  }
}
